<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="bg-content padding15">
          <el-form size="small" label-width="100px" ref="searchRef">
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="公司">
                  <el-select v-model="searchReq.companyId" filterable placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="路由名称">
                  <el-input
                    v-model="searchReq.confName"
                    placeholder="请输入路由名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select v-model="searchReq.status" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <!-- 按钮操作 -->
              <div class="padding15-tb text right">
                <el-button type="primary" size="small" plain @click="searchReq.page = 1; searchList();"><i class="fa fa-search"></i> 搜索</el-button>
                <el-button size="small" @click="reset">重置</el-button>
              </div>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelByIds"
          >删除</el-button>
          <br/><br/>
          <el-table size="small" :data="conditionList.list" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column fixed label="路由名称" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <router-link style="text-decoration: none;" :to="'/main/collection/condition/template/relation/' + scope.row.companyId + '/' + scope.row.groupId + '/' + scope.row.id" class="link-type">
                  <span>{{ scope.row.confName }}</span>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column fixed label="路由类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 2">场景模版</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="groupName"  label="所属策略"  align="center"/>
            <el-table-column fixed property="status"  label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status">有效</span>
                <span v-else>无效</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="createTime"  label="创建时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="conditionList.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!--    编辑    -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="所属策略" prop="groupId"  v-if="isAdd">
              <el-select v-model="form.groupId" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in groupOption"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                  {{ item.groupName }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="路由名称" prop="confName">
              <el-input v-model="form.confName" placeholder="请输入路由名称" />
            </el-form-item>
            <el-form-item label="路由状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="dict in stateList"
                  :key="dict.value"
                  :label="dict.value"
                >{{ dict.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确认</el-button>
            <el-button @click="cancel">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        companyId: null,
        confName: null,
        groupId: null,
        type: 2,
        status: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      conditionList: { 'totalRecords': 0, list: [] },
      stateList: [
        { value: true, label: '有效' },
        { value: false, label: '无效' }
      ],
      // 表单参数
      form: {
        groupId: null,
        type: 2,
        status: false,
        confName: null
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      companyOption: [],
      groupReq: {
        companyId: ''
      },
      isAdd: false
    };
  },
  mounted() {
    this.getCompanyOptionList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.$ajax({
        method: 'get',
        url: '/commonRoute/list',
        params: this.searchReq
      }).then((res) => {
        this.conditionList.list = res.data.list;
        this.conditionList.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.resetForm();
      this.form.id = row.id;
      this.form.companyId = this.searchReq.companyId;
      this.form.groupId = row.groupId;
      this.form.confName = row.confName;
      this.form.status = row.status;
      this.open = true;
      this.isAdd = false;
    },
    handleAdd() {
      this.form.id = null;
      this.resetForm();
      this.form.groupId = null;
      this.open = true;
      this.isAdd = true;
    },
    resetForm() {
      this.form.confName = null;
      this.form.companyId = this.searchReq.companyId;
      this.form.type = 2;
      this.form.status = true;
    },
    // 重置
    reset() {
      this.searchReq.companyId = this.$account().companyId;
      this.searchReq.groupId = null;
      this.searchReq.type = 2;
      this.searchReq.confName = null;
      this.searchReq.status = null;
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if (this.form.id) {
        this.$ajax({
          method: 'post',
          url: '/commonRoute/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$ajax({
          method: 'post',
          url: '/commonRoute/save',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/commonRoute/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除条件路由：${row.confName} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/commonRoute/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    // 公司列表
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.companyOption = res.data;
        this.searchReq.companyId = this.$account().companyId;
        this.getList();
        this.groupReq.companyId = this.searchReq.companyId;
        this.getGroupOptionList(this.groupReq);
      });
    },
    // 策略组列表
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.groupOption = res.data;
      });
    },
    // 搜索
    searchList() {
      this.getList();
      this.groupReq.companyId = this.searchReq.companyId;
      this.getGroupOptionList(this.groupReq);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/condition/template/index.vue